/**
 * When mega menu is clicked add active state to full header
 */
export const navigationClick = () => {
	const submenus = document.querySelectorAll(
		'.main-nav .menu-item-has-children'
	);
	const siteHeader = document.querySelectorAll('.site-header');
	submenus.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.stopPropagation();
			if (el.classList.contains('menu-active')) {
				el.classList.remove('menu-active');
				for (const x of siteHeader) {
					x.classList.remove('header-active');
				}
			} else {
				const active = document.querySelector('.menu-active');
				if (active instanceof window.HTMLElement) {
					active.classList.remove('menu-active');
				}
				el.classList.add('menu-active');
				for (const x of siteHeader) {
					x.classList.add('header-active');
				}
			}
		});
	});

	// remove menu if user clicks anywhere else on the page whilst it's open
	document.body.addEventListener('click', function () {
		const last = document.querySelector('.site-header.header-active');
		const removeActive = document.querySelector(
			'.main-nav .menu-item-has-children.menu-active'
		);
		if (last) last.classList.remove('header-active');
		if (removeActive) removeActive.classList.remove('menu-active');
	});
};
